import type { ProductSortingSchema } from '@coas/validators/const';

/**
 * Sort options. `title` is left as a fallback key for any legacy code that reads it,
 * but the canonical UI title comes from messages/{en,ka}.json under `productGrid.sort*`
 * via `titleForSortKey(key, t)` in ProductSorting.tsx.
 */
export const sortingItems = [
    { key: null, title: 'sortDefault' },
    { key: 'expensive-first', title: 'sortExpensive' },
    { key: 'cheap-first', title: 'sortCheap' },
    { key: 'new-first', title: 'sortNew' },
    { key: 'old-first', title: 'sortOld' },
] satisfies Array<{
    key: ProductSortingSchema;
    title: string;
}>;
